'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = EventRowDirective;

var _eventContentDialogTpl = require('./event-content-dialog.tpl.html');

var _eventContentDialogTpl2 = _interopRequireDefault(_eventContentDialogTpl);

var _eventRowLcEventTpl = require('./event-row-lc-event.tpl.html');

var _eventRowLcEventTpl2 = _interopRequireDefault(_eventRowLcEventTpl);

var _eventRowStatsTpl = require('./event-row-stats.tpl.html');

var _eventRowStatsTpl2 = _interopRequireDefault(_eventRowStatsTpl);

var _eventRowErrorTpl = require('./event-row-error.tpl.html');

var _eventRowErrorTpl2 = _interopRequireDefault(_eventRowErrorTpl);

var _eventRowDebugRulenodeTpl = require('./event-row-debug-rulenode.tpl.html');

var _eventRowDebugRulenodeTpl2 = _interopRequireDefault(_eventRowDebugRulenodeTpl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
function EventRowDirective($compile, $templateCache, $mdDialog, $document, types) {

    var linker = function linker(scope, element, attrs) {

        var getTemplate = function getTemplate(eventType) {
            var template = '';
            switch (eventType) {
                case types.eventType.lcEvent.value:
                    template = _eventRowLcEventTpl2.default;
                    break;
                case types.eventType.stats.value:
                    template = _eventRowStatsTpl2.default;
                    break;
                case types.eventType.error.value:
                    template = _eventRowErrorTpl2.default;
                    break;
                case types.debugEventType.debugRuleNode.value:
                    template = _eventRowDebugRulenodeTpl2.default;
                    break;
                case types.debugEventType.debugRuleChain.value:
                    template = _eventRowDebugRulenodeTpl2.default;
                    break;
            }
            return $templateCache.get(template);
        };

        scope.loadTemplate = function () {
            element.html(getTemplate(attrs.eventType));
            $compile(element.contents())(scope);
        };

        attrs.$observe('eventType', function () {
            scope.loadTemplate();
        });

        scope.types = types;

        scope.event = attrs.event;

        scope.showContent = function ($event, content, title, contentType) {
            var onShowingCallback = {
                onShowing: function onShowing() {}
            };
            if (!contentType) {
                contentType = null;
            }
            $mdDialog.show({
                controller: 'EventContentDialogController',
                controllerAs: 'vm',
                templateUrl: _eventContentDialogTpl2.default,
                locals: { content: content, title: title, contentType: contentType, showingCallback: onShowingCallback },
                parent: angular.element($document[0].body),
                fullscreen: true,
                targetEvent: $event,
                skipHide: true,
                onShowing: function onShowing(scope, element) {
                    onShowingCallback.onShowing(scope, element);
                }
            });
        };

        scope.checkTooltip = function ($event) {
            var el = $event.target;
            var $el = angular.element(el);
            if (el.offsetWidth < el.scrollWidth && !$el.attr('title')) {
                $el.attr('title', $el.text());
            }
        };

        $compile(element.contents())(scope);
    };

    return {
        restrict: "A",
        replace: false,
        link: linker,
        scope: false
    };
} /*
   * Copyright © 2016-2018 The Thingsboard Authors
   *
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
/* eslint-disable import/no-unresolved, import/default */


// WEBPACK FOOTER //
// ./src/app/event/event-row.directive.js